import axios from 'axios'

import { getEnvUrls } from 'helpers/envUrls'

const JSON_BIN_API_KEY = process.env.REACT_APP_JSON_BIN_API_KEY

const jsonBinAxios = axios.create({
    baseURL: process.env.REACT_APP_OHR_V1_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
})

jsonBinAxios.interceptors.request.use(
    options => {
        const { OHR_V1_BASE_URL } = getEnvUrls()

        options.baseURL = OHR_V1_BASE_URL

        options.headers = {
            ...options.headers,
            Authorization: JSON_BIN_API_KEY,
        }

        return options
    },
    error => {
        return error
    }
)

export { jsonBinAxios }
